import React from "react";

export const ExitIcon = () => {
    return <svg className="menu-common__exit-icon" viewBox="0 0 27.58 28"><g id="a" /><g id="b"><g id="c"><path className="d" d="M11.36,14h15.73m-2.86,3.39l2.56-2.56c.39-.39,.39-1.02,0-1.41l-2.8-2.8m-4.77,9.98v3.91c0,1.66-1.34,3-3,3H3.5c-1.66,0-3-1.34-3-3V3.5C.5,1.84,1.84,.5,3.5,.5h12.72c1.66,0,3,1.34,3,3v3.91" /></g></g></svg>;
};